// ── DashboardPeriodBar — 대시보드 상단 sticky 기간 바 ──
// 월/분기/연 토글 + ◀▶ 네비 + "오늘" 리셋
// onChange({ type: 'month'|'quarter'|'year', key: '2026-05', label: '2026년 5월' })
import React from 'react';

function pad(n) { return String(n).padStart(2, '0'); }

export function getInitialPeriod() {
  const d = new Date();
  return {
    type: 'month',
    year: d.getFullYear(),
    month: d.getMonth() + 1,  // 1~12
    quarter: Math.floor(d.getMonth() / 3) + 1,
  };
}

export function periodToKey(p) {
  if (p.type === 'month')   return `${p.year}-${pad(p.month)}`;
  if (p.type === 'quarter') return `${p.year}-Q${p.quarter}`;
  return `${p.year}`;
}

export function periodToLabel(p) {
  if (p.type === 'month')   return `${p.year}년 ${p.month}월`;
  if (p.type === 'quarter') return `${p.year}년 ${p.quarter}분기`;
  return `${p.year}년`;
}

// 월 단위 이전/다음
function adjustPeriod(p, delta) {
  if (p.type === 'month') {
    let m = p.month + delta;
    let y = p.year;
    while (m > 12) { m -= 12; y++; }
    while (m < 1)  { m += 12; y--; }
    return { ...p, year: y, month: m, quarter: Math.floor((m - 1) / 3) + 1 };
  }
  if (p.type === 'quarter') {
    let q = p.quarter + delta;
    let y = p.year;
    while (q > 4) { q -= 4; y++; }
    while (q < 1) { q += 4; y--; }
    const m = (q - 1) * 3 + 1;
    return { ...p, year: y, quarter: q, month: m };
  }
  return { ...p, year: p.year + delta };
}

export default function DashboardPeriodBar({ period, onChange, isMobile }) {
  const handleType = (type) => onChange({ ...period, type });
  const handlePrev = () => onChange(adjustPeriod(period, -1));
  const handleNext = () => onChange(adjustPeriod(period, +1));
  const handleToday = () => onChange(getInitialPeriod());

  const today = new Date();
  const isToday = period.year === today.getFullYear()
    && period.month === today.getMonth() + 1
    && period.type === 'month';

  return (
    <div style={{
      background: '#fff',
      borderRadius: 12,
      padding: isMobile ? '10px 12px' : '10px 18px',
      marginBottom: 14,
      boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
      border: '1px solid #e5e7eb',
      position: 'sticky',
      top: 0,
      zIndex: 50,
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      flexWrap: 'wrap',
    }}>
      {/* 라벨 */}
      <span style={{
        fontSize: 11, fontWeight: 700, color: '#6b7280',
        letterSpacing: '0.04em', textTransform: 'uppercase',
        flexShrink: 0,
      }}>
        📅 기간
      </span>

      {/* 타입 토글 */}
      <div style={{
        display: 'flex', gap: 2,
        background: '#f3f4f6', borderRadius: 8, padding: 2,
      }}>
        {[
          { id: 'month',   label: '월' },
          { id: 'quarter', label: '분기' },
          { id: 'year',    label: '연' },
        ].map(opt => (
          <button key={opt.id} onClick={() => handleType(opt.id)} style={{
            padding: '5px 12px',
            borderRadius: 6,
            border: 'none',
            background: period.type === opt.id ? '#FF6F0F' : 'transparent',
            color: period.type === opt.id ? '#fff' : '#6b7280',
            fontSize: 12, fontWeight: 700,
            cursor: 'pointer',
            transition: 'all 0.15s',
          }}>{opt.label}</button>
        ))}
      </div>

      {/* ◀ */}
      <button onClick={handlePrev} aria-label="이전" style={{
        width: 28, height: 28, borderRadius: '50%',
        border: '1px solid #e5e7eb', background: '#fff',
        color: '#6b7280', fontSize: 13,
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>◀</button>

      {/* 현재 기간 표시 */}
      <span style={{
        padding: '6px 14px', borderRadius: 18,
        background: '#FAFAFA',
        border: '1px solid #F4F4F5',
        color: '#18181B',
        fontSize: 13, fontWeight: 800,
        whiteSpace: 'nowrap',
        minWidth: 110, textAlign: 'center',
      }}>
        {periodToLabel(period)}
      </span>

      {/* ▶ */}
      <button onClick={handleNext} aria-label="다음" style={{
        width: 28, height: 28, borderRadius: '50%',
        border: '1px solid #e5e7eb', background: '#fff',
        color: '#6b7280', fontSize: 13,
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>▶</button>

      {/* 오늘 리셋 */}
      {!isToday && (
        <button onClick={handleToday} style={{
          marginLeft: 'auto',
          padding: '5px 12px', borderRadius: 6,
          border: '1px solid #e5e7eb', background: '#fff',
          color: '#6b7280', fontSize: 11, fontWeight: 600,
          cursor: 'pointer',
        }}>↺ 오늘로</button>
      )}
    </div>
  );
}
